export const loyaltyDetails =
[
    {
      "company": "Bonitas",
      "plan": "Reality core",
      "member": "R70",
      "memberPlus": "R100",
      "family": "R100"
    },
    {
      "company": "Bonitas",
      "plan": "Reality health",
      "member": "R160",
      "memberPlus": "R200",
      "family": "R200"
    },
    {
      "company": "Discovery",
      "plan": "Vitality",
      "member": "R280",
      "memberPlus": "R340",
      "family": "R395"
    },
    {
      "company": "Fedhealth",
      "plan": "Sanlam reality",
      "member": "R215",
      "memberPlus": "R275",
      "family": "R275"
    },
    {
      "company": "Health Squared",
      "plan": "Agility rewards platinum",
      "member": "R228",
      "memberPlus": "R264",
      "family": "R307"
    },
    {
      "company": "Hosmed",
      "plan": "Sanlam reality",
      "member": "R215",
      "memberPlus": "R275",
      "family": "R275"
    },
    {
      "company": "Medshield",
      "plan": "Just rewards premium",
      "member": "R149",
      "memberPlus": "R149",
      "family": "R149"
    },
    {
      "company": "Momentum",
      "plan": "Multiply premium",
      "member": "R238",
      "memberPlus": "R328",
      "family": "R358"
    }
   ]


// WEBPACK FOOTER //
// ./src/views/MedicalAidQuote/QuoteWizard/steps/LoyaltyDetails.jsx